import View from "./view";
import jQuery from 'jquery';

export default abstract class Page extends View {

    private readonly attachPoint : string;

    protected constructor(attachPoint: string, classname: string, ) {
        super(classname);
        this.attachPoint = attachPoint;
    }

    updatePage(force?: boolean) : boolean {
        if (! this.rendered() || force) {
            const elt = this.elt();
            const page = this.render();
            const body = jQuery(this.attachPoint);
            body.empty().append(page);
            console.log("Page attach to DOM");
            return true;
        } else {
            return false;
        }
    }

}
